import React, { useContext, useEffect, useState } from "react";
import {
  getCurrencySymbol,
  getData,
} from "../../../components/utilities/UtilityFunctions";
import { Button, Card, Grid, LinearProgress, Typography } from "@mui/material";
import { BCPTicket } from "../../../components/icons/bcp/BCPIcons";
import { isAppMode } from "../../../global/AppOverlay";
import moment from "moment";
import { postNotification } from "../../../components/utilities/Notifications";
import { AuthContext } from "../../../components/user/BCPAuthProvider";

export default function OrgDashTicketSales(props) {
  const [user, setUser] = useState(null);
  const [feesummary, setFeesummary] = useState(null);
  const [currency, setCurrency] = useState(null);

  const appMode = isAppMode();
  const authContext = useContext(AuthContext);
  const today = moment();

  // Lets get the last 30 days of ticket sales
  const fetchFeesummary = async (_startDate, _endDate) => {
    var returnData;
    var queryStringParameters = {};
    if (_startDate) {
      queryStringParameters.startDate = _startDate.format();
    }
    if (_endDate) {
      queryStringParameters.endDate = _endDate.format();
    }
    try {
      returnData = await getData("/transactions/feesummary", {
        queryStringParameters: queryStringParameters,
      });
    } catch (err) {
      console.error(err);
    }

    return returnData;
  };

  const fetchUser = async (userId) => {
    if (user) {
      return user;
    }
    var returnObj;
    try {
      returnObj = await getData(`/users/${userId}`, {
        queryStringParameters: {
          "expand[]": ["bankAccount"],
        },
      });
    } catch (err) {
      console.error(err);
    }
    return returnObj;
  };

  async function parallelFeesummaryComparison() {
    const taskUser = fetchUser(authContext?.authState?.identity?.userId);
    const task = fetchFeesummary(today.clone().subtract(30, "days"), today);

    return {
      user: await taskUser,
      period: await task,
    };
  }

  async function handleFeesummaryComparison() {
    setFeesummary(null);
    var _feeSummary = await parallelFeesummaryComparison();
    if (_feeSummary?.user) {
      setUser(_feeSummary?.user);
      setCurrency(_feeSummary?.user?.bankAccount?.availableCurrencies?.[0]);
      delete _feeSummary.user;
    }
    setFeesummary({ ..._feeSummary.period });
  }

  useEffect(() => {
    const go = async () => {
      try {
        await handleFeesummaryComparison();
      } catch (err) {
        postNotification("error", err);
      }
    };

    go();
    // eslint-disable-next-line
  }, []);

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} md={8}>
        <Typography variant="h3" fontWeight="700">
          Ticket Sales
        </Typography>
      </Grid>

      <Grid item xs={12} md={4} sx={{ mb: 1 }}>
        <Button
          variant="contained"
          href="/organize/ticket-sales"
          target={`${appMode ? "_blank" : "_self"}`}
          startIcon={<BCPTicket />}
          fullWidth
        >
          View Ticket Sales
        </Button>
      </Grid>

      <Grid
        item
        xs={4}
        sx={{
          textAlign: "center",
        }}
      >
        <Card sx={{ p: 2, borderRadius: "4px" }}>
          {feesummary ? (
            <Typography variant="h3" fontWeight="700" fontSize={"36px"}>
              {getCurrencySymbol(currency) || ""}
              {((feesummary?.gross || 0) / 100).toFixed(2)}
            </Typography>
          ) : (
            <LinearProgress />
          )}
          <Typography variant="body1">Gross</Typography>
          <Typography variant="caption">(Last 30 Days)</Typography>
        </Card>
      </Grid>

      <Grid
        item
        xs={4}
        sx={{
          textAlign: "center",
        }}
      >
        <Card sx={{ p: 2, borderRadius: "4px" }}>
          {feesummary ? (
            <Typography variant="h3" fontWeight="700" fontSize={"36px"}>
              {getCurrencySymbol(currency) || ""}
              {((feesummary?.net || 0) / 100).toFixed(2)}
            </Typography>
          ) : (
            <LinearProgress />
          )}
          <Typography variant="body1">Net</Typography>
          <Typography variant="caption">(Last 30 Days)</Typography>
        </Card>
      </Grid>

      <Grid
        item
        xs={4}
        sx={{
          textAlign: "center",
        }}
      >
        <Card sx={{ p: 2, borderRadius: "4px" }}>
          {feesummary ? (
            <Typography variant="h3" fontWeight="700" fontSize={"36px"}>
              {getCurrencySymbol(currency) || ""}
              {((feesummary?.refundedFees || 0) / 100).toFixed(2)}
            </Typography>
          ) : (
            <LinearProgress />
          )}
          <Typography variant="body1">Refunded</Typography>
          <Typography variant="caption">(Last 30 Days)</Typography>
        </Card>
      </Grid>
    </Grid>
  );
}
